import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function Testimonials() {
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-177" data-mp="3fze3rxqvx3vo">
      <SectionHeading eyebrow="LA CONFIANCE DES PROFESSEURS DE GUITARE" title={<>Ce qu'en disent <span className="text-gold" data-id="element-179" data-mp="3b0az4eetgzo8">les professeurs</span></>} data-id="element-178" data-mp="3fxumq4xemosu" />
      <div className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-180" data-mp="3700ub52rgfay">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-line bg-panel p-5 sm:p-6" data-id="element-181" data-mp="31ybezd8i9fh2">
            <div className="flex gap-1 text-gold" aria-label="5 étoiles sur 5" data-id="element-182" data-mp="2x11tu9s5fpz1">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-183" data-mp="v96ijv9t1nhc" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 font-serif text-base italic leading-relaxed text-cream sm:text-lg" data-id="element-184" data-mp="q9tvpaixoger">« {t.quote} »</blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-185" data-mp="h4ddcmukdq4p">
              <img src={t.photo} alt={t.name} loading="lazy" className="h-12 w-12 shrink-0 rounded-full object-cover" data-id="element-186" data-mp="m5b2jjdzrkfp" />
              <div data-id="element-187" data-mp="79bnfosgsk12">
                <p className="font-bold text-cream" data-id="element-188" data-mp="79v7bb1odihq">{t.name}</p>
                <p className="text-sm text-mute" data-id="element-189" data-mp="c7wnno7pv3pi">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}